import {
  GET_ADMIN_CALL_PRICES,
  GET_ADMIN_CALL_PRICES_SUCCESS,
  GET_ADMIN_CALL_PRICES_ERROR,
  UPDATE_ADMIN_CALL_PRICE,
  UPDATE_ADMIN_CALL_PRICE_SUCCESS,
  UPDATE_ADMIN_CALL_PRICE_ERROR
} from "./actionTypes"

export const getAdminCallPrices = () => {
  return {
    type: GET_ADMIN_CALL_PRICES,
  }
}

export const getAdminCallPricesSuccess = (lead_prices) => {
  return {
    type: GET_ADMIN_CALL_PRICES_SUCCESS,
    payload: lead_prices,
  }
}

export const getAdminCallPricesError = (error) => {
  return {
    type: GET_ADMIN_CALL_PRICES_ERROR,
    payload: error,
  }
}

export const updateAdminCallPrice = (payload) => {
  return {
    type: UPDATE_ADMIN_CALL_PRICE,
    payload: payload,
  }
}

export const updateAdminCallPriceSuccess = (lead_prices) => {
  return {
    type: UPDATE_ADMIN_CALL_PRICE_SUCCESS,
    payload: lead_prices,
  }
}

export const updateAdminCallPriceError = (error) => {
  return {
    type: UPDATE_ADMIN_CALL_PRICE_ERROR,
    payload: error,
  }
}

